export const lang = {
    'loading': '請稍候...',
}


// WEBPACK FOOTER //
// ./src/redux/modules/hft/lang.tsx